import React, { useState } from 'react';
import { ArrowRight, CalendarClock, ChevronDown, ChevronRight } from 'lucide-react';

const fmtDate = (d) => {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); } catch { return d; }
};
const fmtTs = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export const EDD_SOURCE_LABELS = {
  payment_link: 'Payment link (sales)',
  quick_payment_link: 'Quick payment link (sales)',
  payment_captured: 'Payment captured',
  lms_profile: 'LMS — learner updated it',
  lms_stage_flip: 'LMS — stage update',
  lms_enquiry: 'LMS — learner enquiry',
  ops_manual: 'Edited in OPS',
  website_form: 'Website form',
};

export const eddSourceLabel = (s) => EDD_SOURCE_LABELS[s] || (s ? s.replace(/_/g, ' ') : '');

export const EddHistory = ({ lead }) => {
  const [open, setOpen] = useState(false);
  const rows = [...(lead?.edd_history || [])].sort((a, b) => (b.at || '').localeCompare(a.at || ''));
  const current = (lead?.due_date || '').slice(0, 10);

  return (
    <div className="md:col-span-2 border border-slate-200 rounded-lg" data-testid="edd-history">
      <div role="button" tabIndex={0} onClick={() => setOpen(!open)} onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setOpen(!open)} className="w-full flex items-center gap-2 p-4 text-left cursor-pointer" data-testid="edd-history-toggle">
        {open ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
        <CalendarClock className="w-4 h-4 text-slate-500" />
        <h4 className="text-sm font-semibold text-slate-800">EDD &amp; Change History</h4>
        <span className="text-xs text-slate-500" data-testid="edd-history-current">{current ? fmtDate(current) : 'Not set'}</span>
        <span className="ml-auto text-xs text-slate-400">{rows.length} change{rows.length === 1 ? '' : 's'}</span>
      </div>
      {open && (
        <div className="px-4 pb-4">
          <p className="text-xs text-slate-500 mb-2">
            One EDD for this mom, everywhere. The date a rep confirms on a payment link overrules the stored one and
            is sent to the LMS; if the LMS changes it later, that value becomes final.
            {lead?.edd_source && <> Current source: <span className="font-medium text-slate-700">{eddSourceLabel(lead.edd_source)}</span>.</>}
          </p>
          {rows.length === 0 ? (
            <p className="text-xs text-slate-400" data-testid="edd-history-empty">No EDD changes recorded yet.</p>
          ) : (
            <ol className="space-y-2 max-h-56 overflow-y-auto pr-1">
              {rows.map((h, i) => (
                <li key={`${h.at}-${i}`} className="text-xs flex flex-wrap items-center gap-x-2 gap-y-0.5" data-testid={`edd-history-row-${i}`}>
                  <span className={`px-1.5 py-0.5 rounded font-semibold ${String(h.source || '').startsWith('lms') ? 'bg-amber-50 text-amber-700' : 'bg-indigo-50 text-indigo-700'}`}>
                    {String(h.source || '').startsWith('lms') ? 'LMS' : 'OPS'}
                  </span>
                  <span className="text-slate-500">{h.previous_edd ? fmtDate(h.previous_edd) : 'Not set'}</span>
                  <ArrowRight className="w-3 h-3 text-slate-400" />
                  <span className="font-medium text-slate-800">{fmtDate(h.edd)}</span>
                  <span className="text-slate-400">· {h.source_label || eddSourceLabel(h.source)}</span>
                  {(h.actor_name || h.actor) && <span className="text-slate-400">· by {h.actor_name || h.actor}</span>}
                  <span className="text-slate-400 ml-auto">{fmtTs(h.at)}</span>
                  {h.note && <span className="w-full text-slate-500 italic">“{h.note}”</span>}
                </li>
              ))}
            </ol>
          )}
        </div>
      )}
    </div>
  );
};

export default EddHistory;
